import React from "react";
import WaveText from "../WaveText";

export default function EssentialVocabularyGeneratorPanel({
  showEssentialVocabularyGenerator, generatedEssentialVocabulary, showAskMe, showTemplates,
  showWordDefinitionGenerator, showWordTranslationGenerator, showTrueFalseGenerator,
  showWarmUpDiscussionGenerator, showCreateDialogueGenerator, showLeadInActivitiesGenerator,
  showFourOpinionsGenerator, showCommunicativeSituationsGenerator, showGrammarRulesGenerator,
  essentialVocabularyMode, setEssentialVocabularyMode,
  essentialVocabularyInput, setEssentialVocabularyInput,
  essentialVocabularyLevel, setEssentialVocabularyLevel,
  essentialVocabularyPartOfSpeech, setEssentialVocabularyPartOfSpeech,
  essentialVocabularyTranslationLanguage, setEssentialVocabularyTranslationLanguage,
  essentialVocabularyLoading,
  handleEssentialVocabularyGenerate, handleEssentialVocabularyInsert, handleEssentialVocabularyCancel,
}) {
  if (!((showEssentialVocabularyGenerator || generatedEssentialVocabulary) && !showAskMe && !showTemplates && !showWordDefinitionGenerator && !showWordTranslationGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator && !showGrammarRulesGenerator)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, transition: 'opacity 0.22s, transform: 0.22s' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={handleEssentialVocabularyCancel} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4, transition: 'color 0.18s' }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#22223b' }}>Essential Vocabulary</span>
      </div>

      {/* Mode selector */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
        <button
          onClick={() => setEssentialVocabularyMode('myWords')}
          style={{
            flex: 1,
            padding: '10px 16px',
            borderRadius: 8,
            border: '1.5px solid',
            background: essentialVocabularyMode === 'myWords' ? '#8a2be2' : '#fff',
            color: essentialVocabularyMode === 'myWords' ? '#fff' : '#8a2be2',
            borderColor: '#8a2be2',
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
        >
          With My Words
        </button>
        <button
          onClick={() => setEssentialVocabularyMode('generate')}
          style={{
            flex: 1,
            padding: '10px 16px',
            borderRadius: 8,
            border: '1.5px solid',
            background: essentialVocabularyMode === 'generate' ? '#8a2be2' : '#fff',
            color: essentialVocabularyMode === 'generate' ? '#fff' : '#8a2be2',
            borderColor: '#8a2be2',
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
        >
          Generate Useful Vocabulary
        </button>
      </div>

      <textarea
        value={essentialVocabularyInput}
        onChange={e => setEssentialVocabularyInput(e.target.value)}
        placeholder={
          essentialVocabularyMode === 'myWords'
            ? 'Paste your words/phrases here (one per line or separated by commas)\nExample:\ntake care of\nbreak the ice\nby the way'
            : 'Enter a topic (e.g., Technology, Food, Travel, Business)...'
        }
        rows={4}
        style={{
          fontSize: 15,
          padding: '12px',
          borderRadius: 8,
          border: '1.5px solid #cfcfff',
          background: '#f7fbff',
          resize: 'vertical',
          fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
          width: '100%',
          boxSizing: 'border-box'
        }}
      />

      {essentialVocabularyMode === 'generate' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 8 }}>
          <div style={{ display: 'flex', gap: 8 }}>
            <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8 }}>
              CEFR Level:
              <select
                value={essentialVocabularyLevel}
                onChange={e => setEssentialVocabularyLevel(e.target.value)}
                style={{
                  fontSize: 14,
                  padding: '6px 8px',
                  borderRadius: 6,
                  border: '1.5px solid #cfcfff',
                  background: '#fff',
                  cursor: 'pointer',
                  width: '100%',
                  maxWidth: 220,
                  boxSizing: 'border-box'
                }}
              >
                <option value="A1">A1 - Beginner</option>
                <option value="A2">A2 - Elementary</option>
                <option value="B1">B1 - Intermediate</option>
                <option value="B2">B2 - Upper Intermediate</option>
                <option value="C1">C1 - Advanced</option>
                <option value="C2">C2 - Mastery</option>
              </select>
            </label>
            <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, flex: '1 1 0' }}>
              Part of Speech:
              <select
                value={essentialVocabularyPartOfSpeech}
                onChange={e => setEssentialVocabularyPartOfSpeech(e.target.value)}
                style={{
                  fontSize: 14,
                  padding: '6px 8px',
                  borderRadius: 6,
                  border: '1.5px solid #cfcfff',
                  background: '#fff',
                  cursor: 'pointer',
                  width: '100%',
                  maxWidth: 220,
                  boxSizing: 'border-box'
                }}
              >
                <option value="any">Any</option>
                <option value="nouns">Nouns</option>
                <option value="verbs">Verbs</option>
                <option value="adjectives">Adjectives</option>
                <option value="phrases">Phrases</option>
                <option value="idioms">Idioms</option>
                <option value="phrasal_verbs">Phrasal Verbs</option>
              </select>
            </label>
          </div>
          <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8 }}>
            Translation:
            <select
              value={essentialVocabularyTranslationLanguage}
              onChange={e => setEssentialVocabularyTranslationLanguage(e.target.value)}
              style={{
                fontSize: 14,
                padding: '6px 8px',
                borderRadius: 6,
                border: '1.5px solid #cfcfff',
                background: '#fff',
                cursor: 'pointer',
                width: '100%',
                maxWidth: 220,
                boxSizing: 'border-box'
              }}
            >
              <option value="none">None</option>
              <option value="Russian">Russian (Русский)</option>
              <option value="Spanish">Spanish (Español)</option>
              <option value="French">French (Français)</option>
              <option value="German">German (Deutsch)</option>
              <option value="Italian">Italian (Italiano)</option>
              <option value="Portuguese">Portuguese (Português)</option>
              <option value="Chinese">Chinese (中文)</option>
              <option value="Japanese">Japanese (日本語)</option>
              <option value="Korean">Korean (한국어)</option>
              <option value="Arabic">Arabic (العربية)</option>
              <option value="Turkish">Turkish (Türkçe)</option>
              <option value="Polish">Polish (Polski)</option>
              <option value="Ukrainian">Ukrainian (Українська)</option>
            </select>
          </label>
        </div>
      )}

      {essentialVocabularyMode === 'myWords' && (
        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8 }}>
            CEFR Level:
            <select
              value={essentialVocabularyLevel}
              onChange={e => setEssentialVocabularyLevel(e.target.value)}
              style={{
                fontSize: 14,
                padding: '6px 8px',
                borderRadius: 6,
                border: '1.5px solid #cfcfff',
                background: '#fff',
                cursor: 'pointer',
                width: '100%',
                maxWidth: 220,
                boxSizing: 'border-box'
              }}
            >
              <option value="A1">A1 - Beginner</option>
              <option value="A2">A2 - Elementary</option>
              <option value="B1">B1 - Intermediate</option>
              <option value="B2">B2 - Upper Intermediate</option>
              <option value="C1">C1 - Advanced</option>
              <option value="C2">C2 - Mastery</option>
            </select>
          </label>
          <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, flex: '1 1 0' }}>
            Translation:
            <select
              value={essentialVocabularyTranslationLanguage}
              onChange={e => setEssentialVocabularyTranslationLanguage(e.target.value)}
              style={{
                fontSize: 14,
                padding: '6px 8px',
                borderRadius: 6,
                border: '1.5px solid #cfcfff',
                background: '#fff',
                cursor: 'pointer',
                width: '100%',
                maxWidth: 220,
                boxSizing: 'border-box'
              }}
            >
              <option value="none">None</option>
              <option value="Russian">Russian (Русский)</option>
              <option value="Spanish">Spanish (Español)</option>
              <option value="French">French (Français)</option>
              <option value="German">German (Deutsch)</option>
              <option value="Italian">Italian (Italiano)</option>
              <option value="Portuguese">Portuguese (Português)</option>
              <option value="Chinese">Chinese (中文)</option>
              <option value="Japanese">Japanese (日本語)</option>
              <option value="Korean">Korean (한국어)</option>
              <option value="Arabic">Arabic (العربية)</option>
              <option value="Turkish">Turkish (Türkçe)</option>
              <option value="Polish">Polish (Polski)</option>
              <option value="Ukrainian">Ukrainian (Українська)</option>
            </select>
          </label>
        </div>
      )}

      <button
        onClick={handleEssentialVocabularyGenerate}
        disabled={essentialVocabularyLoading || !essentialVocabularyInput.trim()}
        className={essentialVocabularyLoading ? 'magic-generating-btn' : 'magic-btn'}
        style={{
          fontSize: 15,
          padding: '12px 16px',
          borderRadius: 8,
          border: 'none',
          background: essentialVocabularyLoading || !essentialVocabularyInput.trim() ? '#e0e0e0' : '#8a2be2',
          color: essentialVocabularyLoading || !essentialVocabularyInput.trim() ? '#999' : '#fff',
          fontWeight: 600,
          cursor: essentialVocabularyLoading || !essentialVocabularyInput.trim() ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s'
        }}
      >
        {essentialVocabularyLoading ? <WaveText /> : (essentialVocabularyMode === 'myWords' ? 'Create Cards' : 'Do the magic')}
      </button>

      {generatedEssentialVocabulary && (
        <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
          <button
            onClick={handleEssentialVocabularyInsert}
            className="magic-btn"
            style={{ fontSize: 14, padding: '8px 16px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', width: '100%' }}
          >
            Add
          </button>
        </div>
      )}
    </div>
  );
}
